export default "__VITE_PUBLIC_ASSET__9abe8561__"